import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { fontStyle, spacing } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { Search } from '@styled-icons/material/Search';

export const SearchBarWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SearchIcon = styled(Search)`
  width: ${spacing.space24};
  height: ${spacing.space24};
  color: ${nafColor.neutral.neutral4};
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid ${nafColor.neutral.neutral4};
  border-radius: 40px;
  padding: 0 ${spacing.space16};
  box-sizing: border-box;
  height: 40px;
  background-color: ${nafColor.signature.white};
  overflow: hidden;

  &:focus-within {
    border: 2px solid ${themeLight.componentColors.inputElement.borderActive};
    padding: 0 calc(${spacing.space16} - 1px);
  }
`;

export const StyledInput = styled.input`
  filter: grayscale(100%) brightness(110%);
  border: 0;
  background: none;
  appearance: none;
  padding: ${spacing.space8};
  box-sizing: border-box;
  width: 100%;
  height: 35px;
  outline: 0;
  ${fontStyle.article.articleText}
  font-variant: lining-nums;

  &:focus {
    outline: none !important;
  }
`;
